<template>
  <!-- NOTES:
    * where in the world is the close button?
  -->
  <div class="change-email">
    <p class="title">{{this.title}}</p>
    <div class="circle" :class="{active:step == 1}"></div>
    <div class="circle middle" :class="{active:step == 2}"></div>
    <div class="circle" :class="{active:step == 3}"></div>
    <p class="desc">{{this.desc}}</p>
    <div v-if="step == 1" class="step1">
      <input v-model="verCode" type="text" placeholder="Verification code" />
      <p @click="sendCode()" class="send-code">send code</p>
    </div>
    <div v-else-if="step == 2" class="step2">
      <input class="new-email" v-model="newEmail" type="text" placeholder="Enter your new email" />
      <input v-model="verCode" type="text" placeholder="Verification code" />
      <p @click="sendCode()" ref="sendcode" class="send-code">send code</p>
    </div>
    <div v-else class="step3">
      <!-- <email-success/> -->
      <img src="@/assets/mail success.png">
    </div>
    <div class="buttons">
      <p v-if="step < 3" @click="close" class="close">cancel</p>
      <p @click="firebtn" class="btn">{{this.btn}}</p>
    </div>
  </div>
</template>

<script>
import {
  SmsOldPhone,
  SmsNewPhone,
  CheckOldPhone,
  CheckNewPhone
} from "@/api/index.js";
// import EmailSuccess from './emailSuccess.vue'
export default {
  name: "ChangeEmail",
  data() {
    return {
      step: 1,
      newEmail: null,
      verCode: null,
      userinfo: null,
      sended: false,
      title: "",
      desc: "",
      btn: "Next"
    };
  },
  components: {
    // EmailSuccess,
  },
  methods: {
    close(){
      this.$emit('close');
    },
    firebtn() {
      if (this.step < 3) {
        if (this.step == 1) {
          if (!this.verCode) {
            window.alert("Please enter the verification code!");
            return;
          }
          CheckOldPhone({ code: this.verCode }).then(res => {
            this.stopCount = true;
            this.verCode = null;
            console.log(this.stopCount);
            this.step++;
            this.initStep();
          });
        } else if (this.step == 2) {
          if (!this.verCode && !this.newEmail) {
            window.alert("Please fill all the required fields!");
            return;
          }
          CheckNewPhone({ code: this.verCode, email: this.newEmail }).then(
            res => {
              window.alert("look who's got a new phone ;)");
              this.close();
              localStorage.setItem("countDown", null);
              localStorage.setItem("countTime", null);
              this.step++;
              this.initStep();
            }
          );
        }
        // if button 2
      } else {
        this.$emit("close");
        this.step = 1;
      }
    },
    initStep() {
      if (this.step == 1) {
        this.title = `${this.step}. Verify your current email`;
        // this.desc = `The verification code will be sent to ${this.getEmail()}`;
        this.desc = "The verification code will be sent to user1...@gmail.com";
      } else if (this.step == 2) {
        this.title = `${this.step}. Add new email`;
        this.desc = "Enter your new email then send the verification code";
      } else if (this.step == 3) {
        this.title = `${this.step}. Email changed !`;
        this.desc = "Remember to sign-in with your new email next time :)";
        this.btn = "Complete";
      }
    },
    sendCode() {
      if (this.sended) return false;

      if (this.step == 1) {
        SmsOldPhone().then(res => {
          this.sended = true;
          localStorage.setItem("countDown", 60);
          this.sendCountdown();
        });
      } else if (this.step == 2) {
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(this.newEmail)) {
          window.alert("Please enter a valid email address");
          return false;
        }
        SmsNewPhone({ email: this.newEmail }).then(res => {
          this.sended = true;
          localStorage.setItem("countDown", 60);
          this.sendCountdown();
        });
      }
    },
    sendCountdown() {
      let sendcode = this.$refs.sendcode;
      //localStorage.getItem() below is actually effectless, time eventually use 60 as its value
      let time = parseInt(localStorage.getItem("countDown"));
      let that = this;
      sendcode.innerHTML = time + "s";
      let myInterval = window.setInterval(function() {
        if (time <= 0 || this.stopCount) {
          that.sended = false;
          // time = 60;
          console.log(this.stopCount);
          localStorage.setItem("countDown", null);
          sendbtn.innerHTML = "Send";
          window.clearInterval("myInterval");
          return;
        }
        time--;
        console.log("**cd: " + time);
        sendcode.innerHTML = time + "s";
        localStorage.setItem("countDown", time);
        // localStorage.setItem('countTime', new Date().getTime());
      }, 1000);
    },
    getEmail() {
      let arr = this.userinfo.email.split("@");
      return arr[0].substring(0, 4) + "...@" + arr[1];
    }
  },
  created() {
    this.initStep();
  },
  mounted() {
    this.userinfo = this.$store.getters["user/getUserInfo"];
    // console.log(this.userinfo);
  }
};
</script>

<style scoped>
.change-email {
  width: 740px;
  min-height: 450px;
  position: fixed;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 40px 0;
  border-radius: 20px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.16);
  color: #47666f;
}
.title {
  text-shadow: 0 0 0 #47666f;
  font-size: 28px;
  margin-bottom: 10px;
}

.middle {
  margin: 0 20px;
}
.circle {
  width: 10px;
  height: 10px;
  /* background: #000; */
  border: 1px solid #47666f;
  border-radius: 100%;
  display: inline-block;
  margin-bottom: 10px;
}
.active {
  background: #47666f;
}

.desc {
  font-size: 14px;
  width: 250px;
  display: block;
  margin: 0 auto;
  line-height: 20px;
  letter-spacing: 0.2px;
}

.step1 {
  margin-top: 100px;
}
.step2 {
  margin-top: 60px;
}
.step3{
    margin-top: 50px;
}

input {
  font-size: 20px;
  padding: 10px 15px;
  display: block;
  border-radius: 50px;
  border-style: none;
  border: 1px solid rgba(71, 102, 111, 0.6);
  width: 340px;
  margin: 0 auto;
  margin-bottom: 15px;
  color: #47666f;
}

.new-email {
  margin-bottom: 40px;
}

.send-code {
  font-size: 18px;
  font-weight: bold;
}
.btn {
  background: #47666f;
  color: white;
  font-weight: bold;
  padding: 10px;
  width: 130px;
  border-radius: 30px;
  font-size: 20px;
}
.buttons{
  position: absolute;
  bottom: 40px;
  right: 40px;
}
.btn, .close{
  display: inline-block;
  vertical-align: middle;
}

.close{
  margin-right: 15px;
}

.close:hover,
.btn:hover,
.send-code:hover {
  cursor: pointer;
  opacity: 0.8;
}

img{
    width: 220px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChangeMail.vue